import { GroupTypes } from "../../../../enum/GroupTypes";
import { getNodeById } from "../../../../nodeSelector";
import * as pathUtils from "../../../../utils/pathUtils";
import { moveParameterToFunctions } from "../moveParameterToFunctions";
import { moveParameterToGlobals } from "../moveParameterToGlobals";
import { moveParameterFlat } from "../moveParameterFlat";

export const moveParameterAdapter = (root, id, idDestination, relVertical, forceLink) => {
  const _isTop = pathUtils.isFunction(idDestination) || pathUtils.isRoot(idDestination);

  if (_isTop || relVertical) {
    return moveToTop(root, id, idDestination, forceLink);
  } else {
    return moveToTarget(root, id, idDestination, forceLink);
  }
};

const moveToTop = (root, id, idFunction, forceLink) => {
  return moveParameter(root, id, idFunction, null, forceLink);
};

const moveToTarget = (root, id, idParameter, forceLink) => {
  const _idParent = pathUtils.getIdParent(idParameter);
  let { index: _index } = getNodeById(root, idParameter);

  if (_index) {
    if (
      getNodeById(root, id)?.index < _index &&
      pathUtils.getIdParent(id) === _idParent
    ) {
      _index--;
    }
  }

  return moveParameter(root, id, _idParent, _index, forceLink);
};

const moveParameter = (root, idDragged, idTargetParent, index, relVertical) => {
  const _group = pathUtils.determineGroup(idDragged, idTargetParent);

  switch (_group) {
    case GroupTypes.INTERNAL_GLOBALS:
    case GroupTypes.INTERNAL_FUNCTIONS:
      if (relVertical) {
        return moveParameterToFunctions(root, idDragged, idTargetParent, index);
      } else {
        return moveParameterFlat(root, idDragged, idTargetParent, index);
      }
    case GroupTypes.TO_FUNCTIONS:
      return moveParameterToFunctions(root, idDragged, idTargetParent, index);
    case GroupTypes.TO_GLOBALS:
      return moveParameterToGlobals(root, idDragged, idTargetParent, index);
    default:
      return { root };
  }
};
